export const STORAGE_KEYS = {
    AUTH_TOKEN: 'moodle_auth_token',
    USER_EMAIL: 'user_email',
    USER_DATA: 'user_data'
}

export const TOKEN_TTL = 24 * 60 * 60 * 1000

export const setItemWithExpiry = (key, value, ttl = TOKEN_TTL) => {
    const now = new Date()
    const item = {
        value: value,
        expiry: now.getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(item))
}

export const getItemWithExpiry = (key) => {
    const itemStr = localStorage.getItem(key)

    if (!itemStr) {

        return null
    }

    const item = JSON.parse(itemStr)
    const now = new Date()

    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key)

        return null
    }

    return item.value
}
export const isTokenValid = () => {
    return !!getItemWithExpiry(STORAGE_KEYS.AUTH_TOKEN)
}


export const getValidToken = () => {

    return getItemWithExpiry(STORAGE_KEYS.AUTH_TOKEN)
}


export const clearAuthToken = () => {
    localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN)
}

export const clearAuthStorage = () => {
    localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN)
    localStorage.removeItem(STORAGE_KEYS.USER_EMAIL)
    localStorage.removeItem(STORAGE_KEYS.USER_DATA)
}
